import { Component } from '@angular/core';

@Component({
    selector: 'ctfo-dialog-actions',
    templateUrl: './dialog-actions.component.html',
    styleUrls: ['./dialog-actions.component.scss'],
    standalone: false
})
export class DialogActionsComponent {}
